import React, { useEffect } from 'react'
import Pdfh5 from 'pdfh5'

// pdfurl	String	PDF文件地址	-	pdf地址
// data	Array(arraybuffer)	PDF文件流数据	-	pdf文件流 ，与pdfurl二选一(二进制PDF数据。使用类型化数组（Uint8Array）可以提高内存使用率。如果PDF数据是BASE64编码的，请先使用atob（）将其转换为二进制字符串。)
// password	String	PDF密码	null	PDF密码（如果有密码保护）
// goto	Number	页码数字	0	加载pdf跳转到第几页（0表示不跳转）
function Pdf({ url }) {
  useEffect(() => {
    //实例化
    new Pdfh5(document.querySelector('#demo'), {
      pdfurl: url || '',
      textLayer: true,
      lazyLoad: true,
      workerSrc: 'PdfH5/js/pdf.worker.min.js',
      cMapUrl: 'PdfH5/cmaps/',
      standardFontDataUrl: 'PdfH5/standard_fonts/',
      iccUrl: 'PdfH5/iccs/',
      wasmUrl: 'PdfH5/wasm/'
    })
  }, [url])

  return <div id='demo'></div>
}

export default Pdf
